import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const { list, fetch, selectAll, isSelected, toggleSelection, toggleAll, fetching, tableRef, onShow } = props
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Details', accessor: 'details' },
  ]

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
